import type {
  AccessRequestOf,
  ArgsOf,
  RequestOf,
} from "../../../access/types.ts";
import { Access } from "../../../access/types.ts";

export const csaResourceParameters = {
  organization: {
    type: "static" as const,
    label: "Organization",
    description: "The Cisco Secure Access organization",
    optional: true as const,
    isPreselect: true,
    waitForInput: true,
  },
  resource: {
    type: "static" as const,
    label: "Private Resource name or ID",
    description: "The name or ID of the private resource to grant access to",
  },
  resourceName: {
    type: "generated" as const,
    label: "Resource name",
    description: "The name of the private resource",
  },
  resourceId: {
    type: "generated" as const,
    label: "Resource ID",
    description: "The ID of the private resource",
  },
  isCiscoDelegated: {
    type: "generated" as const,
    label: "Requires Cisco access provisioning?",
    description:
      "Flag whether access provisioning happens in Cisco Secure Access",
  },
} as const;

export const CsaAccesses = {
  resource: Access({
    delegation: {},
    description:
      "Add an access rule for a private resource in Cisco Secure Access",
    label: "Private Resource",
    maturity: "preview",
    generated: {
      ruleName: {
        type: "string" as const,
      },
    },
    parameters: csaResourceParameters,
    render: { locator: "resourceName" } as const,
  }),
};

export type CsaAccesses = typeof CsaAccesses;
export type CsaAccess = CsaAccesses[keyof CsaAccesses];

export type CsaResourceAccess = CsaAccesses["resource"];

export type CsaResourceRequest = RequestOf<CsaResourceAccess>;

export type CsaResourceAccessArgs = ArgsOf<CsaResourceAccess>;

export type CsaAccessRequest = AccessRequestOf<CsaAccesses>;
